'use client';

import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

import DepositLanding from '@/features/v2/landings/deposit/DepositLanding';
import Casino from '@/features/v2/landings/register/casino/Casino';
import Sport from '@/features/v2/landings/register/sport/Sport';

import LandingTab from '@/components/marketingLanding/LandingTab';
import WelcomeBonus from '@/components/marketingLanding/WelcomeBonus';

const Alerts = dynamic(() => { return import('@/features/v2/deposit-withdrawals/shared/alerts/Alerts'); }, {
  ssr: false,
});

export default function HomePage() {
  const { slug } = useParams();

  const tabComponents = {
    'bono-deportivo': LandingTab,
    deposito: DepositLanding,
    casino: Casino,
    deporte: Sport,
    default: WelcomeBonus,
  };

  const TabComponent = tabComponents[slug as keyof typeof tabComponents] || tabComponents.default;
  return (
    <>
      <Alerts />
      <TabComponent />
    </>
  );
}
